import { Observable } from "rxjs";
import EnvironmentService from "./environmentService";
import HttpClient from "./httpClient";

let _displayUserInfo = true;

export function setDisplayUserInfo(value: boolean) {
  _displayUserInfo = value;
}

const UserService = {
  displayUserInfo: () => {
    return _displayUserInfo;
  },
  logout(): Observable<void> {
    // todo IDP integration, redirect there
    return HttpClient.get({
      baseUri: EnvironmentService.get().ecomApi + "User/LogOut",
    });
  },
  switchUserConfig(userConfigId: string): Observable<void> {
    return HttpClient.post({
      baseUri:
        EnvironmentService.get().ecomApi + "User/Login/SwitchActiveConfig",
      body: {
        userConfigId: userConfigId,
      },
    });
  },
};

export default UserService;
